import React from 'react';
import { ModuleInterface } from '../types';
import { DateRange } from 'ui';

interface DateFieldProps extends ModuleInterface {}

const DateField: React.FC<DateFieldProps> = ({ layout, mode, manualOptions, ...field }) => {
    const commonProps = {
        customLayout: layout,
        validation: { required: field.required ?? false },
    };

    return <DateRange {...commonProps} {...field} />;
};

export default DateField;
